import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { SolutionManagerPage } from '@/areas/solution-manager/SolutionManager/SolutionManagerPage';
import { sourcingViewModulePermissions } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute(
    '/_authenticated/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/line-items/$sourcingLineItemId',
)({
    staticData: {
        access: { permissions: ['view:sourcing'], modulePermissions: sourcingViewModulePermissions },
        chrome: 'none',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return <SolutionManagerPage {...pathParams} />;
}
